import { render } from "./WorkflowSettingsRequirementTypeColorPicker.vue?vue&type=template&id=e3c453d0&scoped=true"
import script from "./WorkflowSettingsRequirementTypeColorPicker.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsRequirementTypeColorPicker.vue?vue&type=script&lang=js"

import "./WorkflowSettingsRequirementTypeColorPicker.vue?vue&type=style&index=0&id=e3c453d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c453d0"]])

export default __exports__